import type { CommunityList, LabelInValue } from 'models';
import { type ReactNode, useCallback } from 'react';
import { EntitySnippet } from 'ui';
import { images } from 'common/utils';

type CommunityOption = { optionLabel: ReactNode } & LabelInValue;

export const useCommunitySelectCreateOption = () =>
  useCallback(
    (community: CommunityList): CommunityOption => ({
      label: community.name,
      optionLabel: (
        <EntitySnippet
          avatarProps={{
            fallbackPhoto: images.default.communityProfilePhoto,
            size: 'sm',
            src: community.profilePhoto,
          }}
          descriptionProps={{ children: community.organization.name }}
          titleProps={{ children: community.name }}
        />
      ),
      value: community.id,
    }),
    [],
  );
